import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHeartCircleStack24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconHeartCircleStack24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.821 17.821a8.5 8.5 0 1 1 1.049-2.83 7 7 0 0 0-9.86-9.86 8.4 8.4 0 0 0-2.831 1.048A8.5 8.5 0 1 1 17.82 17.82M10.5 20.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14m-2.901-8.79c-.471.472-.51.851-.415 1.253.125.527.525 1.173 1.166 1.87.619.673 1.35 1.272 1.945 1.712l.205.149q.099-.07.205-.15c.595-.439 1.326-1.038 1.945-1.711.641-.697 1.041-1.343 1.166-1.87.095-.402.056-.781-.415-1.252-.313-.314-.502-.34-.557-.344-.08-.007-.208.013-.399.121a2.5 2.5 0 0 0-.528.431 3 3 0 0 0-.19.224l-.002.003a1.5 1.5 0 0 1-2.45 0l-.002-.003-.033-.043a3 3 0 0 0-.157-.18 2.4 2.4 0 0 0-.528-.431c-.191-.11-.319-.129-.399-.122-.055.004-.244.03-.557.344m4-1.463c-.672.419-1.099 1.033-1.099 1.033s-.427-.614-1.1-1.033c-.738-.46-1.774-.685-2.862.403C3.142 14.046 10.5 18.5 10.5 18.5s7.358-4.454 3.962-7.85c-1.088-1.088-2.124-.864-2.863-.403"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHeartCircleStack24);
